import React, { useMemo, useState } from "react";
import { useStyles } from "./ClusterUptimeDowntimeBar.styles";
import { useTranslation } from "react-i18next";
import { percentageChecker } from "utilities/utilities";
import { Box, Typography } from "@mui/material";
import { IClusterUptimeDowntimeBarProps } from "./ClusterUptimeDowntimeBartInterfaces";

export const ClusterUptimeDowntimeBar = ({ downtime, shift }: IClusterUptimeDowntimeBarProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [uptimePercentage, setUptimePercentage] = useState<null | number>(null);
    const [downtimePercentage, setDowntimePercentage] = useState<null | number>(null);

    useMemo(() => {
        if (downtime === 0) {
            setDowntimePercentage(0);
            setUptimePercentage(100);
        } else {
            const downtimePercentageCalculated = Math.ceil((100 * downtime) / shift);
            const uptimePercentageCalculated = Math.floor((100 * (shift - downtime)) / shift);
            setDowntimePercentage(percentageChecker(downtimePercentageCalculated));
            setUptimePercentage(percentageChecker(uptimePercentageCalculated));
        }
    }, [downtime, shift]);

    return (
        <Box className={classes.mainContainer}>
            {!uptimePercentage && !downtimePercentage ? (
                <Box className={classes.titleContainer}>
                    <Typography variant="subtitle2" className={classes.title}>
                        {t("HMI.overall_summary.progress_bar.loading")}
                    </Typography>
                </Box>
            ) : (
                <div className={classes.container}>
                    <Box className={classes.progressBar}>
                        <Box className={classes.uptime} sx={{ width: `${uptimePercentage}%` }}></Box>
                        <Box className={classes.downtime} sx={{ width: `${downtimePercentage}%` }}></Box>
                    </Box>
                    <Box className={classes.titleContainer}>
                        <Typography className={classes.percentageNumber} variant="h3">
                            {uptimePercentage}%
                        </Typography>
                        <Typography className={classes.percentageNumber} variant="h3">
                            {downtimePercentage}%
                        </Typography>
                    </Box>
                </div>
            )}
        </Box>
    );
};
